<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('rfqid')"
          prop="rfqid"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.rfqid"
            @input="form.rfqid = valueTrimLeft($event)"
          />
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('part-number')"
          prop="partID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-part-number
            :model.sync="form.partID"
          ></select-part-number>
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('supplier-company')"
          :rules="getValidationRule('required')"
          prop="supplierCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.supplierCompanyID"
          ></select-company>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4 col-8">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.conditionID"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-1 col-4">
        <el-form-item
          :label="L10n('qty')"
          prop="qty"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12 price-field">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="price-field__field material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
          />
        </el-form-item>
        <el-form-item
          prop="currencyID"
          :label="L10n('currency')"
          :rules="getValidationRule('required')"
          class="price-field__value material-style"
        >
          <select-response
            :model.sync="form.currencyID"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('employee')"
          prop="employeeID"
          :rules="getValidationRule('requiredSelect')"
          class="material-style">
          <select-response
            :model.sync="form.employeeID"
            :data="dataSourceEmployee.records"
            :isLoading="dataSourceEmployee.isLoading"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="stockRemark"
          class="material-style"
        >
          <el-input
            v-model="form.remarks"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormSupplierQuotesNew',
  mixins: [Form],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    }
  }
}
</script>
